var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "home-icon",
    className: "home-icon",
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22 22.75h-20c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h20c.41 0 .75.34.75.75s-.34.75-.75.75z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m3.7002 21.9997h-1.5l.04999-12.02999c0-.85.39001-1.63997 1.06001-2.15997l7-5.45001c.99-.77 2.38-.77 3.38 0l7 5.44c.66.52 1.06 1.32998 1.06 2.16998v12.02999h-1.5v-12.01998c0-.38-.18-.74999-.48-.98999l-7-5.44c-.45-.35-1.08-.35-1.54 0l-7.00001 5.45001c-.3.23-.48.59998-.48.97998z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m14.5 22.75h-5c-.41 0-.75-.34-.75-.75v-3.5c0-1.24 1.01-2.25 2.25-2.25h2c1.24 0 2.25 1.01 2.25 2.25v3.5c0 .41-.34.75-.75.75zm-4.25-1.5h3.5v-2.75c0-.41-.34-.75-.75-.75h-2c-.41 0-.75.34-.75.75z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m9.5 14.5h-2c-.96 0-1.75-.79-1.75-1.75v-1.5c0-.96.79-1.75 1.75-1.75h2c.96 0 1.75.79 1.75 1.75v1.5c0 .96-.79 1.75-1.75 1.75zm-2-3.5c-.14 0-.25.11-.25.25v1.5c0 .14.11.25.25.25h2c.14 0 .25-.11.25-.25v-1.5c0-.14-.11-.25-.25-.25z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m16.5 14.5h-2c-.96 0-1.75-.79-1.75-1.75v-1.5c0-.96.79-1.75 1.75-1.75h2c.96 0 1.75.79 1.75 1.75v1.5c0 .96-.79 1.75-1.75 1.75zm-2-3.5c-.14 0-.25.11-.25.25v1.5c0 .14.11.25.25.25h2c.14 0 .25-.11.25-.25v-1.5c0-.14-.11-.25-.25-.25z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m19.0001 7.75c-.41 0-.75-.32999-.75-.73999l-.02-2.26001h-3.65c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h4.4c.41 0 .75.32999.75.73999l.03 3c-.01.42-.34.76001-.76.76001z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.defe4b1ccf3fe965f5c0a5e98d250caa.svg";
export { ForwardRef as ReactComponent };